export { default } from './useForkRef';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/useForkRef/index.js
// module id = 257
// module chunks = 22